import React from 'react';

function Header({
  onSearch,
  searchQuery,
  filterType,
  onFilterChange,
  user,
  userDisplayName,
  onEditName,
  onLogout,
  onShowLogin,
}) {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo">
            <div className="logo-icon">
              <img
                src="https://i.imgur.com/nVHfbPO.png"
                alt="Eye of Agamotto"
                className="logo-image"
              />
            </div>
            <h1 className="logo-text">Sanctum Sanctorum</h1>
          </div>

          <div className="header-actions">
            {user ? (
              <div className="user-info">
                <span className="user-greeting">Welcome, {userDisplayName}</span>
                <button className="btn btn-secondary user-name-btn" onClick={onEditName}>
                  Edit Name
                </button>
                <button className="btn btn-secondary btn-logout" onClick={onLogout}>
                  Logout
                </button>
              </div>
            ) : (
              <button className="btn btn-secondary header-auth-btn" onClick={onShowLogin}>
                Login
              </button>
            )}
          </div>
        </div>

        <div className="header-tools">
          <div className="search-bar">
            <svg
              className="search-icon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              width="16"
              height="16"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              className="search-input"
              placeholder="Search your items..."
              value={searchQuery}
              onChange={(event) => onSearch(event.target.value)}
            />
          </div>

          <div className="filter-bar">
            <div className="filter-chip" aria-hidden="true">
              <svg
                className="filter-button"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="16"
                height="16"
              >
                <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
              </svg>
              <span className="filter-label">Filter</span>
            </div>
            <div className="filter-select-wrap">
              <select
                className="filter-select"
                value={filterType}
                onChange={(event) => onFilterChange(event.target.value)}
                aria-label="Filter entries by type"
              >
                <option value="all">All Items</option>
                <option value="note">Notes</option>
                <option value="link">Links</option>
                <option value="image">Images</option>
                <option value="video">YouTube</option>
              </select>
              <span className="filter-chevron" aria-hidden="true">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="16"
                  height="16"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
